<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">
  <form [formGroup]="filterGroup" ngProjectAs="filters" class="weather-filters">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Metric</mat-label>
      <mat-select formControlName="metric">
        @for (metric of metrics; track metric.key) { <mat-option [value]="metric.key">{{ metric.label }}</mat-option> }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Weather</mat-label>
      <mat-select formControlName="category">
        <mat-option value="All">All categories</mat-option>
        @for (category of metadata()?.categories ?? []; track category) { <mat-option [value]="category">{{ category }}</mat-option> }
      </mat-select>
    </mat-form-field>
    <mat-checkbox formControlName="includeLowSupport">Include estimates below the five-observation support threshold</mat-checkbox>
    @if (metadata(); as details) {
      <p class="dataset-note">{{ details.studyPeriod }} · {{ details.datasetVersion }} · validation {{ details.sourceValidationStatus }}</p>
    }
    <p class="dataset-note">{{ loading() ? 'Loading association data…' : visibleCount() + ' supported counties' }}</p>
  </form>
  <div class="legend" aria-label="Weather outage association map legend">
    <div class="legend-heading"><strong>{{ currentMetricShortLabel() }}</strong><span>{{ mappedCount() | number }} mapped · {{ visibleCount() | number }} supported</span></div>
    @for (item of legendItems(); track item.label) {
      <div class="legend-item"><span class="swatch" [style.background-color]="item.color"></span><span>{{ item.label }}</span></div>
    }
  </div>
</tgrid-layer-header>
